import axios from "axios";
import { Urls } from "../../slices/urls";
import { ServiceUrls } from "../../serviceUrl";

const getDeviceType = () => {
  if (typeof navigator !== 'undefined') {
    return navigator.userAgent.toLowerCase().includes('mobile') ? 'mobile' : 'web';
  }
  return 'web';
};

export const fetchUserRepo = (sessionKey) => {
  return axios({
    baseURL: ServiceUrls.CUS_SERVICE + process.env.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    // url: 'https://backend-service.careers360.de/api/1/auth/user/',
    url: Urls.USER_DETAIL_API,
    headers: {"sid": sessionKey, "device-type": getDeviceType()},
  });
};